import { mediaList, type MediaItem } from "@/mocks/media";

export function getMediaById(id: string): MediaItem | undefined {
  return mediaList.find((item) => item.id === id);
}

export function getByCategory(category: string): MediaItem[] {
  return mediaList.filter((item) => item.category === category);
}

export function searchMedia(keyword: string): MediaItem[] {
  const kw = keyword.trim().toLowerCase();
  if (!kw) return [];
  return mediaList.filter((item) => {
    const haystack = [
      item.title,
      item.category,
      item.region,
      String(item.year),
      item.director,
      ...item.actors,
      ...item.genre,
      ...item.tags,
      item.synopsis,
    ]
      .join(" ")
      .toLowerCase();
    return haystack.includes(kw);
  });
}

export function getRelated(item: MediaItem, count = 6): MediaItem[] {
  const scored = mediaList
    .filter((m) => m.id !== item.id)
    .map((m) => {
      let score = 0;
      if (m.category === item.category) score += 2;
      score += m.genre.filter((g) => item.genre.includes(g)).length * 2;
      score += m.actors.filter((a) => item.actors.includes(a)).length * 3;
      score += m.tags.filter((t) => item.tags.includes(t)).length;
      return { m, score };
    })
    .sort((a, b) => b.score - a.score || b.m.popularity - a.m.popularity);
  return scored.slice(0, count).map((s) => s.m);
}

export function formatActors(item: MediaItem): string {
  return item.actors.slice(0, 3).join(" / ");
}

export const categories = ["电影", "电视剧", "综艺"];